import { attributes, AttributesMixin, define, type } from "@type-r/models";
import { AssetData, AssetType } from "./assetData";
import { CommonParticipant } from "./commonParticipant";
import { CompanyItem } from "./company";
import { Buyer } from "./invoice";

export const BankInfo = attributes({
    bankName: String,
    bankAlias: String,
    bankAccountNumber: String,
    bankBranchCode: String
});

export interface CounterParty extends AttributesMixin<typeof CounterParty> { }
export const CounterParty = attributes({
    ...BankInfo.attributes,
    company: CompanyItem
});

export interface RAInvoice extends AttributesMixin<typeof RAInvoice> { }
export const RAInvoice = attributes({
    number: String,
    invoiceDate: type(Date).null,
    invoiceDueDate: type(Date).null,
    faceValue: type(Number).value(0),
    currency: String,
    discount: type(Number).value(0),
    netAmount: type(Number).value(0),
    appliedAmount: type(Number).value(0),
    writeOff: type(Number).value(0),
    details: String,
    supplier: CommonParticipant,
    buyer: Buyer
});

export interface RemittanceAdvice extends AttributesMixin<typeof RemittanceAdvice> { }
@define
export class RemittanceAdvice extends AssetData {
    static attributes = {
        ...AssetData.attributes,
        assetType: type(AssetType).value({ id: 5, name: 'Remittance Advice' }),

        payor: CounterParty,
        payee: CounterParty,
        paymentDate: type(Date).null,
        paymentCurrency: String,
        paymentAmount: type(Number).value(0),
        paymentReferenceNumber: String,
        relationShipId: String,
        invoices: [RAInvoice],
        invoice: RAInvoice,
        dataHolder: type(CompanyItem).dontSave
    }

    get isDigitized() {
        return this.state.name == 'Digitized';
    }
    onLoaded() { }
}